// Date handling utilities
export function formatDateToLocal(date: Date | string): string {
  // ALWAYS clone — never mutate the caller's Date. `new Date(date)` copies a
  // Date and parses a string. The setHours(0,0,0,0) below zeroes this local
  // copy to start-of-day; doing it on the caller's object silently turned their
  // "now" into midnight (this is exactly what froze the Home Day Clock at
  // 12:00 AM: ClockWidget passed `now` here, then read now.getHours() after).
  const dateObj = new Date(date);

  // Set to start of day in local timezone
  dateObj.setHours(0, 0, 0, 0);

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Create a Date object from a YYYY-MM-DD string in local timezone
export function parseLocalDate(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  // Set to start of day in local timezone
  date.setHours(0, 0, 0, 0);
  return date;
}

// Compare two dates ignoring time
function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

// Get start of day for a date
function getStartOfDay(date: Date): Date {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}

// Get end of day for a date
function getEndOfDay(date: Date): Date {
  const newDate = new Date(date);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
}

// Get UTC date string from local date
function getUTCDateString(date: Date): string {
  return date.toISOString().split('T')[0];
}